import React from 'react'

interface RevolvingDotProps {
  color?: string
  height?: number
  width?: number
  visible?: boolean
}

export const RevolvingDotSpinner: React.FC<RevolvingDotProps> = ({
  color = '#fabf40',
  height = 100,
  width = 100,
  visible = true,
}) => {
  if (!visible) return null
  const r = width * 0.35
  const cx = width / 2
  const cy = height / 2
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} xmlns="http://www.w3.org/2000/svg">
      <circle cx={cx} cy={cy} r={r} fill="none" stroke={color} strokeWidth={width * 0.06} strokeOpacity="0.25" />
      <circle cx={cx} cy={cy - r} r={width * 0.08} fill={color}>
        <animateTransform
          attributeName="transform"
          type="rotate"
          from={`0 ${cx} ${cy}`}
          to={`360 ${cx} ${cy}`}
          dur="1s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  )
}

interface RingsProps {
  color?: string
  width?: number
  height?: number
  visible?: boolean
}

export const RingsSpinner: React.FC<RingsProps> = ({
  color = 'currentColor',
  width = 45,
  height = 45,
  visible = true,
}) => {
  if (!visible) return null
  return (
    <svg width={width} height={height} viewBox="0 0 45 45" xmlns="http://www.w3.org/2000/svg" stroke={color}>
      <g fill="none" fillRule="evenodd" transform="translate(1 1)" strokeWidth="2">
        <circle cx="22" cy="22" r="6" strokeOpacity="0">
          <animate attributeName="r" begin="1.5s" dur="3s" values="6;22" calcMode="linear" repeatCount="indefinite" />
          <animate attributeName="stroke-opacity" begin="1.5s" dur="3s" values="1;0" calcMode="linear" repeatCount="indefinite" />
          <animate attributeName="stroke-width" begin="1.5s" dur="3s" values="2;0" calcMode="linear" repeatCount="indefinite" />
        </circle>
        <circle cx="22" cy="22" r="6" strokeOpacity="0">
          <animate attributeName="r" begin="3s" dur="3s" values="6;22" calcMode="linear" repeatCount="indefinite" />
          <animate attributeName="stroke-opacity" begin="3s" dur="3s" values="1;0" calcMode="linear" repeatCount="indefinite" />
          <animate attributeName="stroke-width" begin="3s" dur="3s" values="2;0" calcMode="linear" repeatCount="indefinite" />
        </circle>
        <circle cx="22" cy="22" r="8">
          <animate attributeName="r" begin="0s" dur="1.5s" values="6;1;2;3;4;5;6" calcMode="linear" repeatCount="indefinite" />
        </circle>
      </g>
    </svg>
  )
}
